import { useQuery } from "react-query";
import { QUERIES } from "consts";
import { useHttpClient } from "contexts/httpClient";
import { getMspDetails } from "apis/msp.apis";
import { QueryConfigType } from "types/query";
import { IMsp } from "types/apis/msp.types";

export function useMSP(mspId: string, config: QueryConfigType<IMsp> = {}) {
  const httpClient = useHttpClient();
  return useQuery(
    [QUERIES.getMSP, mspId],
    () =>
      getMspDetails({ httpClient, mspId }).then((data) => {
        if (!data.permissions.extendEvaluationPeriod) {
          data.permissions.extendEvaluationPeriod = 60;
        }
        return data;
      }),
    config,
  );
}
